import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map, take } from "rxjs/operators";
import { UserService } from "@modules/user-management/_services/user.service";
import { PermissionsService } from "@shared/services/permissions/permissions.service";
import { RequestedRouteService } from "@core/services/requested-route.service";
import { ToastService } from "@shared/services/toast/toast.service";

type SideMenuPermission =
	| "canViewGlobalDashboard"
	| "canViewEmployeeData"
	| "canViewCpNowData"
	| "canViewCustomers"
	| "canViewServiceDefinition"
	| "canViewCalendar"
	| "canViewUserManagement"
	| "canViewReporting"
	| "canViewSystem"
	| "canViewServiceProvider"
	| "canViewPennyTest"
	| "canViewTppCatalogue"
	| "canViewBankFields"
	| "canViewErrorManagement";

export const sideMenuPermissionGuard = (permission: SideMenuPermission): CanActivateFn => {
	return () => {
		const permissionsService = inject(PermissionsService);
		const userService = inject(UserService);
		const router = inject(Router);
		const requestedRouteService = inject(RequestedRouteService);
		const toastService = inject(ToastService);
		const permissionCheck = permissionsService[permission].bind(permissionsService);

		return userService.getUserDetails().pipe(
			take(1),
			map(user => {
				if (permissionCheck(user.roles ?? [])) return true;

				toastService.showError("You do not have permission to access this content.");
				requestedRouteService.clear();
				return router.parseUrl("/payments");
			})
		);
	};
};
